/* Happy Tails theme: small, dependency-free scripts */
(function () {
  'use strict';

  /* ---------- Money formatting (uses the shop's money format) ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var fmt = format || '${{amount}}';
    function withDelimiters(number, precision, thousands, decimal) {
      thousands = thousands === undefined ? ',' : thousands;
      decimal = decimal === undefined ? '.' : decimal;
      if (isNaN(number) || number == null) return '0';
      var parts = (number / 100.0).toFixed(precision).split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return dollars + (parts[1] ? decimal + parts[1] : '');
    }
    var match = fmt.match(placeholder);
    var value = '';
    switch (match ? match[1] : 'amount') {
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      default: value = withDelimiters(cents, 2);
    }
    var out = fmt.replace(placeholder, value);
    var tmp = document.createElement('div');
    tmp.innerHTML = out;
    return tmp.textContent || out;
  }

  /* ---------- Quantity buttons ---------- */
  document.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-qty-minus]');
    var plus = e.target.closest('[data-qty-plus]');
    if (!minus && !plus) return;
    var wrap = e.target.closest('[data-qty]');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;
    var val = parseInt(input.value, 10) || 1;
    input.value = plus ? val + 1 : Math.max(1, val - 1);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Product page ---------- */
  function initProduct(section) {
    var jsonEl = section.querySelector('[data-product-json]');
    if (!jsonEl) return;
    var product;
    try { product = JSON.parse(jsonEl.textContent); } catch (err) { return; }
    var moneyEl = section.querySelector('[data-money-format]');
    var moneyFormat = '${{amount}}';
    try { if (moneyEl) moneyFormat = JSON.parse(moneyEl.textContent); } catch (err) {}

    var idInput = section.querySelector('[data-variant-id]');
    var addBtn = section.querySelector('[data-add-button]');
    var priceWrap = section.querySelector('[data-price-wrapper]');
    var fieldsets = Array.prototype.slice.call(section.querySelectorAll('fieldset[data-option-position]'));

    var stage = section.querySelector('[data-stage]');
    var counter = section.querySelector('[data-counter]');
    var slides = Array.prototype.slice.call(section.querySelectorAll('.product__slide[data-media-id]'));
    var mobileQuery = window.matchMedia('(max-width: 989px)');

    function markActive(mediaId) {
      var index = 0;
      slides.forEach(function (s, i) {
        var on = s.getAttribute('data-media-id') === String(mediaId);
        s.hidden = !on;
        if (on) index = i;
      });
      section.querySelectorAll('[data-thumb]').forEach(function (t) {
        var active = t.getAttribute('data-media-id') === String(mediaId);
        t.classList.toggle('is-active', active);
        if (active) {
          t.setAttribute('aria-current', 'true');
          if (t.scrollIntoView && mobileQuery.matches) t.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        } else t.removeAttribute('aria-current');
      });
      if (counter) counter.textContent = (index + 1) + ' / ' + slides.length;
    }

    function showMedia(mediaId) {
      if (!mediaId) return;
      var target = section.querySelector('.product__slide[data-media-id="' + mediaId + '"]');
      if (!target) return;
      markActive(mediaId);
      if (mobileQuery.matches && stage) {
        stage.scrollTo({ left: target.offsetLeft - stage.offsetLeft, behavior: 'smooth' });
      }
    }

    // Swipe gallery on phones: keep counter and thumbnails in sync
    if (stage) {
      var scrollTimer;
      stage.addEventListener('scroll', function () {
        if (!mobileQuery.matches) return;
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function () {
          var i = Math.round(stage.scrollLeft / Math.max(stage.clientWidth, 1));
          var slide = slides[Math.min(Math.max(i, 0), slides.length - 1)];
          if (slide) markActive(slide.getAttribute('data-media-id'));
        }, 60);
      }, { passive: true });
    }

    section.querySelectorAll('[data-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () { showMedia(btn.getAttribute('data-media-id')); });
    });

    // Sticky add-to-cart bar on phones
    var sticky = section.querySelector('[data-sticky-buy]');
    var stickyAdd = section.querySelector('[data-sticky-add]');
    var stickyPrice = section.querySelector('[data-sticky-price]');
    if (sticky && addBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        var past = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', past);
      }).observe(addBtn);
    }

    function selectedOptions() {
      return fieldsets.map(function (fs) {
        var checked = fs.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }

    function findVariant(opts) {
      return product.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }

    function renderPrice(variant) {
      if (!priceWrap) return;
      var html = '<div class="price price--large' + (variant && variant.compare_at_price > variant.price ? ' price--sale' : '') + '">';
      if (!variant) {
        html += '<span class="price__current">Unavailable</span></div>';
        priceWrap.innerHTML = html;
        return;
      }
      html += '<span class="price__current">' + formatMoney(variant.price, moneyFormat) + '</span>';
      if (variant.compare_at_price > variant.price) {
        var save = Math.floor((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
        html += '<s class="price__compare"><span class="visually-hidden">Regular price</span>' + formatMoney(variant.compare_at_price, moneyFormat) + '</s>';
        html += '<span class="badge badge--save">Save ' + save + '%</span>';
      }
      if (!variant.available) html += '<span class="badge badge--soldout">Sold out</span>';
      html += '</div>';
      priceWrap.innerHTML = html;
    }

    function markUnavailable(opts) {
      // Grey out values that have no available variant with the other current choices
      fieldsets.forEach(function (fs, index) {
        fs.querySelectorAll('input[data-option-input]').forEach(function (input) {
          var test = opts.slice();
          test[index] = input.value;
          var match = product.variants.find(function (v) {
            return v.available && v.options.every(function (o, i) { return o === test[i]; });
          });
          var label = fs.querySelector('label[for="' + input.id + '"]');
          if (label) label.classList.toggle('is-unavailable', !match);
        });
      });
    }

    function update() {
      var opts = selectedOptions();
      fieldsets.forEach(function (fs, i) {
        var out = fs.querySelector('[data-selected-value]');
        if (out) out.textContent = opts[i] || '';
      });
      var variant = findVariant(opts);
      renderPrice(variant);
      markUnavailable(opts);
      if (!addBtn) return;
      var buttons = [addBtn];
      if (stickyAdd) buttons.push(stickyAdd);
      if (!variant) {
        buttons.forEach(function (b) { b.disabled = true; b.textContent = 'Unavailable'; });
        return;
      }
      idInput.value = variant.id;
      buttons.forEach(function (b) {
        b.disabled = !variant.available;
        b.textContent = variant.available ? 'Add to cart' : 'Sold out';
      });
      if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price, moneyFormat);
      if (variant.featured_media) showMedia(variant.featured_media.id);
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    fieldsets.forEach(function (fs) {
      fs.addEventListener('change', update);
    });
    if (fieldsets.length) markUnavailable(selectedOptions());
  }

  /* ---------- Product recommendations ---------- */
  function initRecommendations(el) {
    var url = el.getAttribute('data-url');
    if (!url || el.children.length) return;
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var fresh = doc.querySelector('[data-recommendations]');
        if (fresh && fresh.innerHTML.trim().length) el.innerHTML = fresh.innerHTML;
      })
      .catch(function () {});
  }

  /* ---------- Collection sort ---------- */
  function initSort(form) {
    var select = form.querySelector('[data-sort-select]');
    if (!select) return;
    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* ---------- Close mobile menu on outside click / Escape ---------- */
  function initMobileNav(details) {
    document.addEventListener('click', function (e) {
      if (details.open && !details.contains(e.target)) details.open = false;
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && details.open) {
        details.open = false;
        var s = details.querySelector('summary');
        if (s) s.focus();
      }
    });
  }

  function init(root) {
    root = root || document;
    root.querySelectorAll('[data-product-section]').forEach(initProduct);
    root.querySelectorAll('[data-recommendations]').forEach(initRecommendations);
    root.querySelectorAll('[data-sort-form]').forEach(initSort);
  }

  document.addEventListener('DOMContentLoaded', function () {
    init(document);
    document.querySelectorAll('[data-mobile-nav]').forEach(initMobileNav);
  });

  // Re-run when a section is edited in the Shopify theme editor
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
